import React, { useEffect } from 'react'
import RangeSlider from "react-range-slider-input";
import { getImages } from '../Common/const';
import { useLocation } from 'react-router-dom';
const SrpLeft = ({
    mobFilter,
    handleCloseFilter,
    numberFormatter,
    handlePriceSliderChange,
    handleMileageSliderChange,
    value,
    handleInputChange,
    handleFilterModal,
    filteredVehicleData,
    currentFilterData,
    priceFilterData,
    mileageFilterData,
    clearAllFilters,
    locationFilters,
    setLocationFilters,
    clearFilter
}) => {
    return (
        <>
            <div className={`srp-left ${mobFilter ? "open" : ""}`}>
                <div className='srpl-heading d-lg-none'>
                    <div className='csmodal-title'>Filters</div>
                    <button type='button' className='filter-close' onClick={handleCloseFilter}>
                        <img src={getImages('close-icon.webp')} alt='close' />
                    </button>
                </div>
                <div className='srpl-body'>
                    {/* <div className='d-lg-none mb-3'>
                        <div className='xs-title fw-500 mb-2'>Applied Filters</div>
                        <div className='d-flex mob-fl-tags'>
                            {locationFilters.map((item, index) =>
                                <div className='tag-btn me-2 mb-2' key={index}>
                                    {item}
                                    <img
                                        src={getImages('close-anticon.svg')}
                                        alt="Remove"
                                        onClick={() => {
                                            clearFilter(item);

                                            setLocationFilters(locationFilters.filter((location) => location !== item));
                                        }}
                                        style={{ cursor: "pointer" }}
                                    />
                                </div>
                            )}
                            <div className='tag-btn me-2 mb-2'>{priceFilterData.current_min == priceFilterData.min ? "Min" : numberFormatter(priceFilterData.current_min,true)} - {priceFilterData.current_max == priceFilterData.max ? "Max" : numberFormatter(priceFilterData.current_max,true)} <img src={getImages('close-anticon.svg')} /></div>
                            <div className='tag-btn me-2 mb-2'>{mileageFilterData.current_min == mileageFilterData.min ? "Min" : numberFormatter(mileageFilterData.current_min,true)} - {mileageFilterData.current_max == mileageFilterData.max ? "Max" : numberFormatter(mileageFilterData.current_max,true)} <img src={getImages('close-anticon.svg')} /></div>
                            {Object.keys(currentFilterData).filter((index) => currentFilterData[index].some(item => item.isSelected) > 0).map((item, index) =>
                                <div className='tag-btn me-2 mb-2' key={index}>{item}
                                    <img
                                        src={getImages('close-anticon.svg')}
                                        alt="Remove"
                                        onClick={() => {
                                            clearFilter(item);
                                        }}
                                        style={{ cursor: "pointer" }}
                                    />
                                </div>
                            )}
                        </div>
                    </div> */}
                    <div className='sl-card-box mb-3'>
                        <div className='xs-title mb-2'>Location</div>
                        <div className="custom-checkbox location-checkbox w-100 mb-2">
                            <input
                                type="checkbox"
                                name="location"
                                value="Boerne, TX"
                                id='location1'
                                checked={locationFilters.includes("Boerne, TX")}
                                // checked={true}
                                onChange={(e) => {
                                    if (e.target.checked) {                 
                                        setLocationFilters([...locationFilters, "Boerne, TX"]);
                                    } else {                               
                                        setLocationFilters(locationFilters.filter(loc => loc !== "Boerne, TX"));
                                    }
                                }}
                            />
                            <label htmlFor="location1" className='w-100'>Boerne, TX</label>
                        </div>
                        <div className="custom-checkbox location-checkbox w-100">
                            <input
                                type="checkbox"
                                name="location"
                                value="Austin, TX"
                                id='location2'
                                checked={locationFilters.includes("Austin, TX")}
                                // checked={true}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setLocationFilters([...locationFilters, "Austin, TX"]);
                                    } else {
                                        setLocationFilters(locationFilters.filter(loc => loc !== "Austin, TX"));
                                    }
                                }}
                            />
                            <label htmlFor="location2" className='w-100'>Austin, TX</label>
                        </div>
                    </div>
                    <div className='sl-card-box mb-3'>
                        <div className='xs-title'>Price Range</div>
                        <div className='price-range-slider'>
                            <RangeSlider
                                value={[priceFilterData.current_min,priceFilterData.current_max]}
                                onInput={handlePriceSliderChange}
                                min={priceFilterData.min}
                                max={priceFilterData.max}
                            />
                            <div className='d-flex align-items-center justify-content-between pr-labels'>
                                <div>{numberFormatter(priceFilterData.current_min,true)}</div>
                                <div>{numberFormatter(priceFilterData.current_max,true)}</div>
                            </div>
                            <div className='d-flex align-items-center justify-content-between mt-3'>
                                <div>
                                    <input
                                        type="text"
                                        value={priceFilterData.current_min == priceFilterData.min ? "Min" : numberFormatter(priceFilterData.current_min,true)}
                                        className='pr-input-field'
                                        onChange={(e) => handleInputChange(0, e)}
                                    />
                                </div>
                                <div>
                                    <input
                                        type="text"
                                        value={priceFilterData.current_max == priceFilterData.max ? "Max" : numberFormatter(priceFilterData.current_max,true)}
                                        className='pr-input-field'
                                        onChange={(e) => handleInputChange(1, e)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='sl-card-box mb-3'>
                        <div className='xs-title'>Mileage Range</div>
                        <div className='price-range-slider'>
                            <RangeSlider
                                value={[mileageFilterData.current_min,mileageFilterData.current_max]}
                                onInput={handleMileageSliderChange}
                                min={mileageFilterData.min}
                                max={mileageFilterData.max}
                            />
                            <div className='d-flex align-items-center justify-content-between pr-labels'>
                                <div>{numberFormatter(mileageFilterData.current_min)}</div>
                                <div>{numberFormatter(mileageFilterData.current_max)}</div>
                            </div>
                            <div className='d-flex align-items-center justify-content-between mt-3'>
                                <div>
                                    <input
                                        type="text"
                                        value={mileageFilterData.current_min == mileageFilterData.min ? "Min" : numberFormatter(mileageFilterData.current_min)}
                                        className='pr-input-field'
                                        onChange={(e) => handleInputChange(0, e)}
                                    />
                                </div>
                                <div>
                                    <input
                                        type="text"
                                        value={mileageFilterData.current_max == mileageFilterData.max ? "Max" : numberFormatter(mileageFilterData.current_max)}
                                        className='pr-input-field'
                                        onChange={(e) => handleInputChange(1, e)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='sl-list'>
                        <div className='row'>
                            <div className='col-md-6 col-6'>
                                <button type='button'
                                    className={`sl-card-box sl-sm-card text-center p-2 w-100 d-flex align-items-center ${currentFilterData.year.some(item => item.isSelected) ? "active" : ""}`}
                                    onClick={() => {
                                        handleFilterModal("year");
                                        //reloadData();
                                    }}
                                >
                                    <div className='w-100'>
                                        <div className='mb-2'>
                                            <img src={getImages('year.svg')} />
                                        </div>
                                        <div className='slc-title'>Year</div>
                                    </div>
                                </button>
                            </div>
                            <div className='col-md-6 col-6'>
                                <button type='button'
                                    className={`sl-card-box sl-sm-card text-center p-2 w-100 d-flex align-items-center ${currentFilterData.make.some(item => item.isSelected) ? "active" : ""}`}
                                    onClick={() => {
                                        handleFilterModal("make");
                                        //reloadData();
                                    }}
                                >
                                    <div className='w-100'>
                                        <div className='mb-2'>
                                            <img src={getImages('make.svg')} />
                                        </div>
                                        <div className='slc-title'>Make</div>
                                    </div>
                                </button>
                            </div>
                            <div className='col-md-6 col-6'>
                                <button type='button'
                                    className={`sl-card-box sl-sm-card text-center p-2 w-100 d-flex align-items-center ${currentFilterData.model.some(item => item.isSelected) ? "active" : ""}`}
                                    onClick={() => {
                                        handleFilterModal("model");
                                        //reloadData();
                                    }}
                                >
                                    <div className='w-100'>
                                        <div className='mb-2'>
                                            <img src={getImages('model.svg')} />
                                        </div>
                                        <div className='slc-title'>Model</div>
                                    </div>
                                </button>
                            </div>
                            <div className='col-md-6 col-6'>
                                <button type='button'
                                    className={`sl-card-box sl-sm-card text-center p-2 w-100 d-flex align-items-center ${currentFilterData.body_style.some(item => item.isSelected) ? "active" : ""}`}
                                    onClick={() => {
                                        handleFilterModal("body_style");
                                        //reloadData();
                                    }}
                                >
                                    <div className='w-100'>
                                        <div className='mb-2'>
                                            <img src={getImages('body-style.svg')} />
                                        </div>
                                        <div className='slc-title'>Body Style</div>
                                    </div>
                                </button>
                            </div>
                            {/*<div className='col-md-6 col-6'>
                                <button type='button'
                                    className={`sl-card-box sl-sm-card text-center p-2 w-100 d-flex align-items-center ${currentFilterData.mileage.some(item => item.isSelected) ? "active" : ""}`}
                                    onClick={() => {
                                        // handleFilterModal("mileage");
                                        //reloadData();
                                    }}
                                >
                                    <div className='w-100'>
                                        <div className='mb-2'>
                                            <img src={getImages('mileage.svg')} />
                                        </div>
                                        <div className='slc-title'>Mileage</div>
                                    </div>
                                </button>
                            </div>
                            <div className='col-md-6 col-6'>
                                <button type='button'
                                    className={`sl-card-box sl-sm-card text-center p-2 w-100 d-flex align-items-center ${currentFilterData.exterior_color.some(item => item.isSelected) ? "active" : ""}`}
                                    onClick={() => {
                                        //handleFilterModal("exterior_color");
                                        //reloadData();
                                    }}
                                >
                                    <div className='w-100'>
                                        <div className='mb-2'>
                                            <img src={getImages('ext-color.svg')} />
                                        </div>
                                        <div className='slc-title'>Ext Color</div>
                                    </div>
                                </button>
                            </div>
                            <div className='col-md-6 col-6'>
                                <button type='button'
                                    className={`sl-card-box sl-sm-card text-center p-2 w-100 d-flex align-items-center ${currentFilterData.interior_color.some(item => item.isSelected) ? "active" : ""}`}
                                    onClick={() => {
                                        //handleFilterModal("interior_color");
                                        //reloadData();
                                    }}
                                >
                                    <div className='w-100'>
                                        <div className='mb-2'>
                                            <img src={getImages('int-color.svg')} />
                                        </div>
                                        <div className='slc-title'>Int Color</div>
                                    </div>
                                </button>
                            </div>
                            <div className='col-md-6 col-6'>
                                <button type='button'
                                    className={`sl-card-box sl-sm-card text-center p-2 w-100 d-flex align-items-center ${currentFilterData.transmission.some(item => item.isSelected) ? "active" : ""}`}
                                    onClick={() => {
                                        //handleFilterModal("transmission");
                                        //reloadData();
                                    }}
                                >
                                    <div className='w-100'>
                                        <div className='mb-2'>
                                            <img src={getImages('transmission.svg')} />
                                        </div>
                                        <div className='slc-title'>Transmission</div>
                                    </div>
                                </button>
                            </div>*/}
                        </div>
                    </div>
                </div>
                <div className='mt-2 d-none d-lg-block'>
                    <button type='button' className='clear-filter-btn' onClick={() => {clearAllFilters()}}>Clear Filters</button>
                </div>
                <div className='d-lg-none'>
                    <div className='d-flex align-items-center justify-content-between filter-bottom'>
                        <div>
                            <button type='button' className='clear-filter-btn' onClick={() => clearAllFilters()}>
                                Clear All
                            </button>
                        </div>
                        <div>
                            {filteredVehicleData && <button type='button' className='btn-theme text-black'>View {filteredVehicleData.length} Matches</button>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SrpLeft